



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { MyDetails } from '../../models/MyPlayerDetails';
import { Player } from '../../models/Player';
import { PlayerRole } from '../../models/PlayerRole';

@Component({})
export default class Header extends Vue {
  @Prop({ required: true }) currentPlayer!: MyDetails | null;
  @Prop({ required: true }) members!: Player[];

  constructor() {
    super();
  }

  get playerOrViewerIcon() {
    return this.currentPlayer?.role === PlayerRole.Viewer ? 'user-secret' : 'user';
  }

  get playersCount() {
    return this.members.filter(m => m.role === PlayerRole.Player).length;
  }
  get viewersCount() {
    return this.members.filter(m => m.role === PlayerRole.Viewer).length;
  }
  get totalMembersCount() {
    return this.members.length;
  }

  updateDetails() {
    this.$emit('updateDetailsClicked');
  }

  openSideMenu() {
    this.$emit('openSideMenuClicked');
  }
}
